module.exports = __webpack_public_path__ + "media/my_images/owner/step4-852031014cd41c2447444cb5af40c10f.svg";